import ErrorPage from "../shared/error/error.customer.m";
import Gateway from "@phoenixreisen/gateway";
import Model, { getWebtexte } from "./model";
import Layout from "./layout/layout.m";
import Page from "./components/page.m";
import DateTime from "date-and-time";
import m from "mithril";
import "date-and-time/locale/de";
import "./index.scss";
(() => {
    const { env } = process;
    DateTime.locale("de");
    Gateway.setApiErrorUrl(env.API_ERROR);
    Gateway.setApiUrl(`${env.GATEWAY}/call-json-service`);
    if (!Model.webtexte) {
        getWebtexte()
            .then((result) => {
            Model.webtexte = result;
            m.redraw();
        })
            .catch(() => {
            m.route.set("/error");
        });
    }
    m.route(document.body.querySelector("#root"), "/", {
        "/": {
            render: () => [m(Layout, { key: "root" }, m(Page))],
        },
        "/error": {
            render: () => [m(Layout, { key: "error" }, m(ErrorPage))],
        },
    });
})();
